// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foot .footer{color:#407338;text-align:center;font-size:18px}.foot{margin:0 auto;width:1200px;background-color:#d1e4d4}", ""]);
// Exports
module.exports = exports;
